import { trpc } from "lib/trpc";
import { ClientCurrentUser } from "@compass/shared/types";

/**
 * Fetches every organization as a slim {id, name} tuple. The query has a long
 * stale window and is gated to Compass users, so mounting it once at the app
 * shell is enough — the rest of the app reads from the React Query cache.
 *
 * Org pickers should consume this hook directly; consumers don't need to
 * coordinate fetches because every call shares the same query key.
 */
export const useAllOrganizations = (currentUser?: ClientCurrentUser) => {
    return trpc.organizations.listAll.useQuery(undefined, {
        enabled: Boolean(currentUser?.isCompassUser),
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
